module.exports = __webpack_public_path__ + "img/23_78.8ac6afef.png";